export default function colorByNumber(number) {
    const limitedNumber = number % 15
    if (limitedNumber === 1) return '#5B9BD5'
    if (limitedNumber === 2) return '#ED7D31'
    if (limitedNumber === 3) return '#A5A5A5'
    if (limitedNumber === 4) return '#FFC003'
    if (limitedNumber === 5) return '#70AD47'
    if (limitedNumber === 6) return '#4471C4'
    if (limitedNumber === 7) return '#D15E11'
    if (limitedNumber === 8) return '#29BA74'
    if (limitedNumber === 9) return '#871E1E'
    if (limitedNumber === 10) return '#29BABA'
    if (limitedNumber === 11) return '#4029BA'
    if (limitedNumber === 12) return '#9329BA'
    if (limitedNumber === 13) return '#BA2992'
    if (limitedNumber === 14) return '#95BA29'
    if (limitedNumber === 0) return '#BA2929'
    return '#A4EBD9'
}



// WEBPACK FOOTER //
// src/utils/dataEnhancer/utils/colorByNumber.js